import { useState } from "react";
import Modal from "../MapModal/MapModal";
import OTownMap from "../SVG_Component/OTownMap";
import CanvassMap from "../CanvassMap/CanvassMap";
import Sidebar from "../MapSideBar/MapSideBar";
import styles from "./MapPage.module.css";

export default function MapPage() {
  const [showModal, setShowModal] = useState(true);

  // zones currently selected on the map
  const [selectedZones, setSelectedZones] = useState([]);

  // home zone (used by OTownMap mode)
  const [homeZone, setHomeZone] = useState(null);

  // which map is active
  const [activeMap, setActiveMap] = useState("canvass");

  // canvassing data per zone
  const [zoneCoverage, setZoneCoverage] = useState({});

  /*
  Example structure:

  zoneCoverage = {
    zone_3016: {
      peopleReached: 12,
      percentCovered: 70,
      notes: "Many apartments locked"
    }
  }
  */

  // toggle region selection
  const toggleZone = (zoneId) => {
    setSelectedZones((prev) =>
      prev.includes(zoneId)
        ? prev.filter((z) => z !== zoneId)
        : [...prev, zoneId]
    );
  };

  // update canvassing data for a zone
  const updateZoneCoverage = (zoneId, data) => {
    setZoneCoverage((prev) => ({
      ...prev,
      [zoneId]: {
        ...prev[zoneId],
        ...data
      }
    }));
  };

  return (
    <>
      <Modal show={showModal} onClose={() => setShowModal(false)} />

      <div style={{ display: "flex" }}>
        <div className={styles.mapLayout}>

          {/* MAP */}
          <div className={styles.map}>

            {activeMap === "canvass" && (
              <CanvassMap
                selectedZones={selectedZones}
                toggleZone={toggleZone}
                zoneCoverage={zoneCoverage}
              />
            )}

            {activeMap === "otown" && (
              <OTownMap
                selectedZones={selectedZones}
                setSelectedZones={setSelectedZones}
                homeZone={homeZone}
                setHomeZone={setHomeZone}
              />
            )}

          </div>

          {/* SIDEBAR */}
          <div className={styles.sidebar}>
            <Sidebar
              activeMap={activeMap}
              selectedZones={selectedZones}
              homeZone={homeZone}
              setHomeZone={setHomeZone}
              zoneCoverage={zoneCoverage}
              updateZoneCoverage={updateZoneCoverage}
            />
          </div>

        </div>
      </div>
    </>
  );
}